import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { IconButton, Modal, ModalBody, Text } from "@wojo/ui";
import React, { useState } from "react";
import { FiShare } from "react-icons/fi";
import { SocialMediaShare } from "../../../social-media-share";
import { useTourPageContext } from "../../_client/context";

type Props = {
    tourName: string;
    cardImage: string;
    continent: string;
    tourCode: string;
};

export const TourSocialMediaShare: React.FC<React.PropsWithChildren<Props>> = ({
    tourName,
    cardImage,
    tourCode,
}) => {
    const { pageConfig } = useTourPageContext();
    const { productPage } = useI18n("productPage");
    const [isOpen, setOpen] = useState(false);
    const heading = productPage.tourHero.socialShare.heading.l();

    if (pageConfig.disableSocialShare) {
        return null;
    }

    return (
        <>
            <IconButton
                variant="secondary"
                palette="monochrome"
                type="button"
                icon={<FiShare aria-hidden />}
                onClick={() => {
                    setOpen(true);
                }}
                ariaLabel={heading}
                title={heading}
                style={{ padding: 0 }}
            />
            <Modal
                isOpen={isOpen}
                onCloseRequested={() => setOpen(false)}
                accessibleTitle={heading}
            >
                <ModalBody style={{ textAlign: "center" }}>
                    <Text.Heading order="3" tag="h2">
                        {heading}
                    </Text.Heading>
                    <Text.Body
                        style={{
                            marginTop: "var(--g-spacing-sm)",
                            marginBottom: "var(--g-spacing-md)",
                        }}
                    >
                        {tourName}
                    </Text.Body>
                    <SocialMediaShare
                        pinterestDescription={productPage.tourHero.socialShare.pinterest.description.l(
                            { tourName },
                        )}
                        twitterTitle={productPage.tourHero.socialShare.twitter.description.l()}
                        cardImage={cardImage}
                        emailSubject={productPage.tourHero.socialShare.email.subject.l()}
                        emailBody={productPage.tourHero.socialShare.email.body.l()}
                        onSocialMediaShareClick={(label) => {
                            gtmSendEvent({
                                event: "track",
                                ga4Tracking: {
                                    ga4_object: "SOCIAL_MEDIA",
                                    ga4_action: "SHARE",
                                    tourCode: tourCode,
                                    tourName: tourName,
                                    method: label,
                                },
                            });
                        }}
                    />
                </ModalBody>
            </Modal>
        </>
    );
};
